export default function WhoThisIsFor() {
  const idealClients = [
    {
      icon: 'ri-water-flash-line',
      title: 'Sprinkler Contractors',
      description: 'Installation, inspection, and maintenance of fire sprinkler systems.'
    },
    {
      icon: 'ri-alarm-warning-line',
      title: 'Fire Alarm Companies',
      description: 'Commercial fire detection, notification, and monitoring systems.'
    },
    {
      icon: 'ri-fire-line',
      title: 'Extinguisher Service Providers',
      description: 'Portable fire extinguisher sales, service, and inspection.'
    },
    {
      icon: 'ri-shield-star-line',
      title: 'Life-Safety Integrators',
      description: 'Comprehensive fire protection and life safety system integration.'
    },
    {
      icon: 'ri-building-2-line',
      title: 'Industrial Safety Service Companies',
      description: 'Specialized fire protection for industrial and manufacturing facilities.'
    }
  ];

  const notFor = [
    'Startups without an established customer base',
    'Companies without recurring customers or service agreements',
    'Businesses that don\'t value long-term customer relationships',
    'Companies looking for quick-fix marketing tactics',
    'Residential-only service providers'
  ];

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Who This Is For
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We work with established fire protection and life safety companies that value relationships.
          </p>
        </div>

        <div className="mb-20">
          <h3 className="text-3xl font-bold text-gray-900 mb-8 text-center">Ideal Clients</h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {idealClients.map((client, index) => (
              <div
                key={index}
                className="bg-white p-8 rounded-lg shadow-sm hover:shadow-md transition-shadow border-l-4 border-red-600"
              >
                <div className="w-14 h-14 flex items-center justify-center bg-red-100 rounded-lg mb-6">
                  <i className={`${client.icon} text-3xl text-red-600`}></i>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-3">{client.title}</h4>
                <p className="text-gray-600 leading-relaxed">{client.description}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-white p-12 rounded-lg shadow-sm">
          <h3 className="text-3xl font-bold text-gray-900 mb-8 text-center">Not For</h3>
          <div className="max-w-3xl mx-auto">
            <ul className="space-y-4">
              {notFor.map((item, index) => (
                <li key={index} className="flex items-start gap-4">
                  <div className="flex-shrink-0 w-6 h-6 flex items-center justify-center mt-1">
                    <i className="ri-close-circle-line text-2xl text-gray-400"></i>
                  </div>
                  <span className="text-lg text-gray-700">{item}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="mt-12 text-center">
            <p className="text-lg text-gray-600 italic">
              If you're building a business for the long term and understand that relationships drive revenue, we should talk.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}